import { TagObject } from '@decisiv/ui-components/lib/components/TagInput';

import { parseCsvTags } from './parseCsvTags';

export const transformTags = (tags: (string | TagObject)[]) => {
  return parseCsvTags(tags).map((tag) => {
    if (typeof tag === 'string' && tag.length !== 17) {
      return {
        text: tag,
        color: 'danger' as const,
      };
    }

    return tag;
  });
};
